import { Helmet } from 'react-helmet'
import { SmartOosTable, SmartOosFileUpload } from 'components/smartOos'
import { useState } from 'react'

const SmartOOS = () => {
  const [refetch, setRefetch] = useState(false)
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Smart OOS</title>
      </Helmet>

      {/* Upload button */}
      <SmartOosFileUpload setRefetch={setRefetch} />

      {/* Smart OOS file upload history */}
      <SmartOosTable refetch={refetch} />
    </>
  )
}

export default SmartOOS
